/// <reference types="@types/google.maps" />
import { useEffect, useState } from 'react';
import { GOOGLE_MAPS_API_KEY } from '@/config/google-maps';

export const useGoogleMaps = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState<string | null>(null);

  useEffect(() => {
    // Check if already loaded
    if (window.google && window.google.maps) {
      setIsLoaded(true);
      return;
    }

    // Check if script is already being loaded
    const existingScript = document.getElementById('google-maps-script');
    if (existingScript) {
      existingScript.addEventListener('load', () => setIsLoaded(true));
      return;
    }

    // Use browser key from config
    if (!GOOGLE_MAPS_API_KEY) {
      console.warn(
        'Google Maps browser key missing in config/google-maps.ts. Autocomplete disabled, but manual address entry still works.'
      );
      setIsLoaded(false);
      return;
    }

    // Load the script
    const script = document.createElement('script');
    script.id = 'google-maps-script';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.addEventListener('load', () => {
      setIsLoaded(true);
    });

    script.addEventListener('error', () => {
      setLoadError('Failed to load Google Maps');
    });

    document.head.appendChild(script);

    return () => {
      // Cleanup if needed
    };
  }, []);

  return { isLoaded, loadError };
};
